import { CommonModule, DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';


import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';

import { StyleClassModule } from 'primeng/styleclass';

import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ErrorsComponent,} from '@fitness-force/common/errors'
import { RruleComponent } from '../../../rrule/rrule.component';
import {AssignedToComponent} from '@fitness-force/common/assigned-to'
import { BehaviorSubject, Observable } from 'rxjs';
import {
  ClassType,
  ClassTypeById,
  CreateClassRequest,
  CreateRecurringClassRequest,
  RepeatRuleResponse,
  Room,
  TENANTSINTERFACE,
} from '@fitness-force/models';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  CLASS_TYPE_STATE,
  ROOM_LIST_STATE,
  STAFF_STATE,
  TENANTS_INFO,
} from 'apps/ff-frontend/src/app/state/app.state';
import {
  ClassTypeService,
  ClassService,
  TimeconversionService,
} from '@fitness-force/api';
import { RippleModule } from 'primeng/ripple';
import { GooglePlacesComponent } from '@fitness-force/common/google-places';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToastMessageService } from '@fitness-force/api';
import { Ienum, StaffStatus } from '@fitness-force/enum';
import { SelectRoomComponent } from '../../../select-room/select-room.component';
import { InputNumberComponent } from 'libs/shared/src/lib/components/input-number/input-number.component';
import { CheckRecurringAvailability, StaffAvailableResponse } from 'libs/staff-availability-lib/src/lib/models/staff-availability';
import { StaffAvailabilityService } from 'libs/staff-availability-lib/src/lib/services/staff-availability.service';
import { SkeletonModule } from 'primeng/skeleton';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'create-class',
  templateUrl: './create-class.component.html',
  styleUrls: ['./create-class.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService, DatePipe ],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    InputTextModule,
    ButtonModule,
    DatePickerModule,
    SelectModule,
    DividerModule,
    AvatarModule,
    StyleClassModule,
    FormsModule,
    ReactiveFormsModule,
    RruleComponent,
    AssignedToComponent,
    ErrorsComponent,
    ErrorMsgComponent,
    BreadcrumbModule,
    RippleModule,
    GooglePlacesComponent,
    InputNumberModule,
    SkeletonModule,
    SelectRoomComponent,
    InputNumberComponent,
    ConfirmPopupModule,
    TranslateModule,
    ToggleSwitchModule,
    MessageModule
]
})
export class CreateClassComponent implements OnInit {
  getAccessTenantList$: Observable<any> | any;
  showClssSubType = new BehaviorSubject(false);
  getAccessedStaffList$: Observable<any> | any;
  classTypeList$ = new BehaviorSubject<ClassType[]>([]);
  classSubTypeList$ = new BehaviorSubject<any[]>([]);
  roomList$ = new BehaviorSubject<any[]>([]);

  selectedClassType: Observable<ClassType> | any;
  selectedClassSubType: Observable<any> | any;

  selectedTrainerId = new BehaviorSubject(0);
  selectedBehaviourType: any;
  selectedRoom: { name: string } | any;
  selectedTrainer: | { name: string; availability: string; ff_picture: string } | undefined;

  classTypeToShow = 5;
  createClassForm: UntypedFormGroup = new UntypedFormGroup({});
  //minimumDate = new Date().setHours(0, 0, 0, 0);
  minimumDate:Date;
  minimumTime: any;
  RRuleObject = <RepeatRuleResponse>{};
  selectedLocation: { name: string; lat: number; lon: number } | any = {};
  isVirtal = false;

  showMaxCapacityInput = false;
  showMaxWaitlistInput = false;
  showRRule = false;

  errorDataModal = [] as any;
  errorMessages = [] as any;
  showErrorPopup$ = new BehaviorSubject(false);
  tenantId: number;

  disableSaveBtn = false;
  error = new BehaviorSubject(null as (AppErrors | null));
  filterStaffIds = new BehaviorSubject<number[]>([0]);
  showAddRoomPopup = false;
  staffAppointmentAvailability: any = new Map();
  isStaffAvailable:boolean=true;
  showSkeleton:boolean=false;


  constructor(
    private store: Store,
    private router: Router,
    private translate: TranslateService,
    private fb: UntypedFormBuilder,
    private classTypeService: ClassTypeService,
    private classService: ClassService,
    private timeConversionService: TimeconversionService,
    public datePipe: DatePipe,
    private toastMessageService: ToastMessageService,
    private cd: ChangeDetectorRef,
    private staffAvailabilityService : StaffAvailabilityService,
    private confirmationService: ConfirmationService
  ) {
    
  }

  ngOnInit(): void {
    this.minimumDate=new Date(new Date().setHours(0, 0, 0, 0));
    this.componentInit();
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      if (tenant.selected_tenant.id > 0 && tenant.selected_tenant.id != this.tenantId) {
        this.tenantId = tenant.selected_tenant.id;
        this.store.dispatch({ type: 'ROUTER_GO' });
        this.LoadForm();
        this.GetRooms();
        this.GetStaffs();
        this.GetClassTypes();
      }
    });

  }

  LoadForm() {
    const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
    this.createClassForm = this.fb.group({
      classType: ['', [Validators.required]],
      classSubType: [''],
      selectedBehaviourType: [''],
      selectedTrainer: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      startTime: ['', [Validators.required]],
      selectedRoom: [''],
      comments: [''],
      virtualUrl: ['', [Validators.pattern(reg)]],
      maxCapacity: [],
      maxWaitlist: [],
      isDropInAllowed: [false],
      rRule: [''],
      placeName: [''],
      placeId: [''],
      latitude: [''],
      longitude: [''],
      accepts_trial: [false]
    });

    this.SelectedTrainerFormControl.valueChanges.subscribe(
      (trainer: any) => {
        this.checkStaffAvailability();
      }
    );
  }

  GetClassTypes() {
    this.store.select(CLASS_TYPE_STATE).subscribe((response: ClassType[]) => {
      if (response)
        this.classTypeList$.next(response.filter((cls) => cls.status.toLowerCase() == 'active'));
      if (this.classTypeList$.value.length > 0) {
        this.selectedClassType = this.classTypeList$.value[0];
        this.ClassTypeFormControl.setValue(this.selectedClassType);
        this.GetAcceptsTrialFormControl.setValue(this.selectedClassType.allows_trial)
        if (this.selectedClassType.is_room_mandatory) {
          this.SelectedRoomFormControl.setValidators(Validators.required);
          this.SelectedRoomFormControl.updateValueAndValidity();
        }
        this.GetClassType(this.classTypeList$.value[0].id);
      }
    });
  }

  get classTypes$(): Observable<ClassType[]> {
    return this.classTypeList$;
  }

  GetRooms() {
    this.store.dispatch({ type: 'FETCH_ROOM_LIST' });
    this.store.select(ROOM_LIST_STATE).subscribe((responseData: Room[]) => {
      this.roomList$.next(responseData);
    });
  }

  SelectClassType(classType: any) {
    this.selectedClassType = classType.value;
    this.ClassTypeFormControl.setValue(this.selectedClassType);
    this.GetAcceptsTrialFormControl.setValue(this.selectedClassType.allows_trial)
    if (this.selectedClassType.is_room_mandatory) {
      this.SelectedRoomFormControl.setValidators(Validators.required);
      this.SelectedRoomFormControl.updateValueAndValidity();
    }
    this.GetClassType(this.selectedClassType.id);
    this.checkStaffAvailability();
  }

  SelectClassSubType(classSubType: any) {
    if (classSubType.value) this.selectedClassSubType = classSubType.value;
    else this.selectedClassSubType = classSubType;
    this.ClassSubTypeFormControl.setValue(this.selectedClassSubType);
  }

  GetClassType(classTypeId: number) {
    this.classTypeService.getSingleClassType(this.tenantId, classTypeId).subscribe({
      next: (response: ClassTypeById) => {
        if (response.subtypes) {
          this.classSubTypeList$.next(response.subtypes);
          this.selectedClassSubType = response.subtypes[0];
          this.ClassSubTypeFormControl.setValue(this.selectedClassSubType);
          this.showClssSubType.next(true);
        } else {
          this.selectedClassSubType = null;
          this.showClssSubType.next(false);
        }
      },
      error: () => {
        this.selectedClassSubType = null;
        this.showClssSubType.next(false);
      },
    });
  }



  GetStaffs() {
    this.store.select(STAFF_STATE).subscribe((data: any) => {
      if (data && data.staffList && data.staffList.length > 0) {
        const validStaff: number[] = [];
        this.getAccessedStaffList$ = data.staffList.filter((staff: any) => {
          const oStaffStatus = this.OStaffStatus.find((o: any) => (o.value == staff.status || o.key == staff.status));
          if (oStaffStatus!.value == StaffStatus.Active || oStaffStatus!.key == StaffStatus.Active) {
            if (staff.role.toLowerCase() == 'admin' || (staff.role.toLowerCase() == 'staff' && staff.can_take_class)) {
              validStaff.push(staff.id);
              return staff;
            }
          }
        });
        this.filterStaffIds.next(validStaff);
      }
    });

  }

  getPlaceDetails(place: any) {
    this.selectedLocation.name = place.formatted_address;
    this.selectedLocation.lat = place.geometry.location.lat();
    this.selectedLocation.lon = place.geometry.location.lng();
    this.PlaceNameControl.setValue(this.selectedLocation.name);
    this.PlaceIdFormControl.setValue(place.place_id);
    this.LatitudeFormControl.setValue(this.selectedLocation.lat);
    this.LongitudeFormControl.setValue(this.selectedLocation.lon);
  }

  SetIsVirtual(isVirtual: boolean) {
    this.isVirtal = isVirtual;
    if (isVirtual) {
      this.SelectedRoomFormControl.setValidators(null);
      this.SelectedRoomFormControl.setValue(null);
    } else {
      this.SelectedRoomFormControl.setValidators(this.selectedClassType.is_room_mandatory ? Validators.required : null);
      this.VirtualUrlFormControl.setValidators(null);
      this.VirtualUrlFormControl.setValue(null);
    }
    this.SelectedRoomFormControl.updateValueAndValidity();
    this.VirtualUrlFormControl.updateValueAndValidity();
  }

  toggleMaxCapacity(event: boolean) {
    this.showMaxCapacityInput = event;
    if (event) this.MaxCapacityFormControl.setValidators(Validators.required);
    else this.MaxCapacityFormControl.clearValidators();

    this.MaxCapacityFormControl.updateValueAndValidity()
    this.createClassForm.updateValueAndValidity();
  }

  toggleMaxWaitlist(event: boolean) {
    this.showMaxWaitlistInput = event;
    if (event) this.MaxWaitListFormControl.setValidators(Validators.required);
    else this.MaxWaitListFormControl.clearValidators();

    this.MaxWaitListFormControl.updateValueAndValidity()
    this.createClassForm.updateValueAndValidity();
  }

  FetchRRuleData(e: any): void {
    this.RRuleObject.RRule = e.RRule;
    this.RRuleObject.RRuleText = e.RRuleText;
    this.checkStaffAvailability();
  }

  HideRRule(e: any): void {
    this.showRRule = e;
  }

  HideErrorPopup() {
    this.showErrorPopup$?.next(false);
    this.errorMessages = [];
  }

  getSelectedColor(classType: any) {
    return `border-${classType.color}-400 bg-${classType.color}-50 text-${classType.color}-400 font-bold`;
  }

  onTrainerChange(trainer: any) {
    //this.checkStaffAvailability();
  }

  confirm(event: Event) {
    if (this.createClassForm.valid) {
      let translation: any;
      this.translate.get(['BILL_OWNER_CHANGE.CHANGE_INFO','common.BUTTONS.BUTTON-TEXT-YES','common.BUTTONS.BUTTON-TEXT-NO'])
        .subscribe((translations) => {
          translation = translations;
        });
      this.confirmationService.confirm({
          target: event.target as EventTarget,
          key:'bookconfirm',
          message: "Are you sure that you want to proceed?",
          icon: 'fa fa-exclamation-triangle',
          acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
          rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
          accept: () => {
           this.CreateClass(this.createClassForm);
          },
          reject: () => {
            
          }
      });
    }
    else {
      Object.keys(this.createClassForm.controls).forEach((field) => {
        const control = this.createClassForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
}

  CreateClass(form: UntypedFormGroup) {
    if (this.createClassForm.valid) {
      this.disableSaveBtn = true;
      let createClassRequest: CreateClassRequest = {} as CreateClassRequest;
      let createRecurringClassRequest: CreateRecurringClassRequest = {} as CreateRecurringClassRequest;
      createClassRequest.class_type_id = this.selectedClassType.id;
      createClassRequest.coach_id = form.value.selectedTrainer.id;
      createClassRequest.comments = form.value.comments;
      createClassRequest.is_virtual = this.isVirtal;
      createClassRequest.virtual_url = form.value.virtualUrl;
      createClassRequest.room_id = form.value.selectedRoom ? form.value.selectedRoom.id : 0,
      createClassRequest.start_date_time = this.timeConversionService.GetUTCDateTimeByDateAndTime(form.value.startDate, form.value.startTime);
      createClassRequest.sub_type_id = this.selectedClassSubType ? this.selectedClassSubType.id : 0;
      createClassRequest.is_dropin_allowed = form.value.isDropInAllowed;
      createClassRequest.place_id = form.value.placeId;
      createClassRequest.latitude = form.value.latitude ? form.value.latitude : 0;
      createClassRequest.longitude = form.value.longitude ? form.value.longitude : 0;
      createClassRequest.max_capacity = form.value.maxCapacity ? form.value.maxCapacity : 0;
      createClassRequest.max_waitlist = form.value.maxWaitlist ? form.value.maxWaitlist : 0;
      createClassRequest.accepts_trial = form.value.accepts_trial;
      createRecurringClassRequest = createClassRequest;

      if (this.RRuleObject.RRule) {
        createRecurringClassRequest.recurring_rule = this.RRuleObject.RRule;
        createRecurringClassRequest.start_date = createClassRequest.start_date_time;
        createRecurringClassRequest.start_time = this.timeConversionService.GetUTCTimeFromDate(form.value.startTime);

        this.classService.CreateRecurringClass(this.tenantId, createRecurringClassRequest).subscribe({
          next: async (response: any) => {
            this.translate
              .get('SCHEDULE.VIEWCLASS.MSG.CREATE_RECURRING_CLASS_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            if (response.info && response.info.length > 0) {
              response.info.forEach((info: any) => {
                this.translate.get('SCHEDULE.MSG.OVERLAP_MESSAGE',
                  {
                    type: info.jsonObject.identifier,
                    startDate: this.timeConversionService.formatDate(this.timeConversionService.ConvertUTCToLocalDateTime(info.jsonObject.startDateTime), 'medium'),
                    endDate: this.timeConversionService.formatDate(this.timeConversionService.ConvertUTCToLocalDateTime(info.jsonObject.endDateTime), 'medium')
                  })
                  .subscribe((translation) => {
                    this.toastMessageService.showWarning(translation);
                  });
              })
            }
            await this.timeout(1000);
            this.router.navigateByUrl('/schedule');
          },
          error: (error) => {
            this.disableSaveBtn = false;
            this.handleError(error);
          },
        });
      } else {
        this.classService.CreateClass(this.tenantId, createClassRequest)
          .subscribe({
            next: async (response: any) => {
              this.translate
                .get('SCHEDULE.VIEWCLASS.MSG.CREATE_CLASS_MSG')
                .subscribe((translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              if (response.info && response.info[0]) {
                let info = response.info[0];
                this.translate.get('SCHEDULE.MSG.OVERLAP_MESSAGE',
                  {
                    type: info.jsonObject.identifier,
                    startDate: this.timeConversionService.formatDate(this.timeConversionService.ConvertUTCToLocalDateTime(info.jsonObject.startDateTime), 'medium'),
                    endDate: this.timeConversionService.formatDate(this.timeConversionService.ConvertUTCToLocalDateTime(info.jsonObject.endDateTime), 'medium')
                  })
                  .subscribe((translation) => {
                    this.toastMessageService.showWarning(translation);
                  });
              }
              await this.timeout(1000);
              this.router.navigateByUrl('/schedule');
            },
            error: (error) => {
              this.disableSaveBtn = false;
              this.handleError(error);
            },
          });
      }
    }
    else {
      Object.keys(this.createClassForm.controls).forEach((field) => {
        const control = this.createClassForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  handleError(error: any) {
    this.error.next(error);
    this.showErrorPopup$.next(true);
  }


  GoToFitnessCalendar() {
    this.router.navigate(['/schedule']);
  }

  GoToClassType() {
    this.router.navigate(['/admin/class-categories/create-class-category']);
  }

  timeout(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  OnScheduleDateSelect(selectedDate: Date) {
    const currentDate = new Date();
    if (selectedDate.getTime() > currentDate.getTime()) {
      this.minimumTime = null;
      if (this.StartTimeFormControl.value) {
        this.StartTimeFormControl.setValue(this.getEndDate());
      }
    }
    else {
      this.minimumTime = new Date();
      if (this.StartTimeFormControl.value) {
        this.StartTimeFormControl.setValue(this.getEndDate());
      }
    }
    this.checkStaffAvailability();
  }




  checkStaffAvailability()
  {
    if(this.selectedClassType && this.StartDateFormControl.value && this.SelectedTrainerFormControl.value.id)
    {
      this.showSkeleton=true;
      const endDateTime: Date = this.getEndDate();
      endDateTime.setMinutes(endDateTime.getMinutes() + this.selectedClassType.duration_in_minutes);
      if (this.RRuleObject.RRule) {
        let request:CheckRecurringAvailability ={} as CheckRecurringAvailability;
        request.recurring_start_date =  this.timeConversionService.GetUTCDateTimeByDateAndTime(this.StartDateFormControl.value, this.StartTimeFormControl.value);
        request.recurring_end_date = this.timeConversionService.ConvertLocalDateTimeToUTC(endDateTime);
        request.start_time =  this.getTimeFromDateString(this.StartTimeFormControl.value);
        request.end_time =  this.getTimeFromEndDateString(endDateTime);
        request.recurring_rule = this.RRuleObject.RRule;
        this.staffAvailabilityService.checkStaffAvailabilityForRecurringClass(this.tenantId, this.SelectedTrainerFormControl.value.id, request).subscribe({
          next: async (response: StaffAvailableResponse) => {
            this.isStaffAvailable =response.result;
            this.showSkeleton=false;
            this.cd.detectChanges();
          },
          error: (error:any) => {
            this.disableSaveBtn = false;
            this.isStaffAvailable = true;
            this.showSkeleton=false;
            this.cd.detectChanges();
            //this.ShowToastErrors(error);
          },
        });
      }
      else{
        this.staffAppointmentAvailability.set('start_date', { name: 'start_date', value: this.timeConversionService.GetUTCDateTimeByDateAndTime(this.StartDateFormControl.value, this.StartTimeFormControl.value) });
        this.staffAppointmentAvailability.set('end_date', { name: 'end_date', value: this.timeConversionService.ConvertLocalDateTimeToUTC(endDateTime)});
        this.staffAvailabilityService.checkStaffAvailabilityForClass(this.tenantId, this.SelectedTrainerFormControl.value.id, [...this.staffAppointmentAvailability.values()]).subscribe({
          next: async (response: StaffAvailableResponse) => {
            this.isStaffAvailable =response.result;
            this.showSkeleton=false;
            this.cd.detectChanges();
          },
          error: (error:any) => {
            this.isStaffAvailable = true;
            this.disableSaveBtn = false;
            this.showSkeleton=false;
            this.cd.detectChanges();
          },
        });
      }
    }
  }

  getTimeFromDateString(dateString:any) {
    if(dateString =='') return `00:00:00`;
    const date = this.timeConversionService.ConvertLocalDateTimeToUTCInDateObject(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  getTimeFromEndDateString(dateString:any) {
    if(dateString =='') return `00:00:00`;
    const date = this.timeConversionService.ConvertLocalDateTimeToUTCInDateObject(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    date.setSeconds(-1);
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  getEndDate(): any {
    return new Date(this.StartDateFormControl.value.getFullYear(),
      this.StartDateFormControl.value.getMonth(), this.StartDateFormControl.value.getDate(),
      this.StartTimeFormControl.value.getHours(), this.StartTimeFormControl.value.getMinutes());
  }


  get ClassTypeFormControl(): UntypedFormControl {
    return this.createClassForm.controls.classType as UntypedFormControl;
  }

  get ClassSubTypeFormControl(): UntypedFormControl {
    return this.createClassForm.controls.classSubType as UntypedFormControl;
  }


  get StartDateFormControl(): UntypedFormControl {
    return this.createClassForm.controls.startDate as UntypedFormControl;
  }

  get GetStartDateFormValue(): any {
    return this.createClassForm.controls.startDate.value;
  }

  get StartTimeFormControl(): UntypedFormControl {
    return this.createClassForm.controls.startTime as UntypedFormControl;
  }

  get GetStartTimeFormValue(): any {
    return this.createClassForm.controls.startTime.value;
  }

  get MaxCapacityFormControl(): UntypedFormControl {
    return this.createClassForm.controls.maxCapacity as UntypedFormControl;
  }

  get GetMaxCapacityFormValue(): any {
    return this.createClassForm.controls.maxCapacity.value;
  }

  get MaxWaitListFormControl(): UntypedFormControl {
    return this.createClassForm.controls.maxWaitlist as UntypedFormControl;
  }

  get GetMaxWaitListFormValue(): any {
    return this.createClassForm.controls.maxWaitlist.value;
  }

  get SelectedTrainerFormControl(): UntypedFormControl {
    return this.createClassForm.controls.selectedTrainer as UntypedFormControl;
  }

  get GetSelectedTrainerFormValue(): any {
    return this.createClassForm.controls.selectedTrainer.value;
  }

  get SelectedRoomFormControl(): UntypedFormControl {
    return this.createClassForm.controls.selectedRoom as UntypedFormControl;
  }
  get GetSelectedRoomFormValue(): any {
    return this.createClassForm.controls.selectedRoom.value;
  }

  get CommentsFormControl(): UntypedFormControl {
    return this.createClassForm.controls.comments as UntypedFormControl;
  }

  get GetCommentsFormValue(): any {
    return this.createClassForm.controls.comments.value;
  }

  get VirtualUrlFormControl(): UntypedFormControl {
    return this.createClassForm.controls.virtualUrl as UntypedFormControl;
  }

  get GetVirtualUrlFormValue(): any {
    return this.createClassForm.controls.virtualUrl.value;
  }

  get DropInFormControl(): UntypedFormControl {
    return this.createClassForm.controls.isDropInAllowed as UntypedFormControl;
  }

  get GetDropInFormValue(): any {
    return this.createClassForm.controls.isDropInAllowed.value;
  }

  get PlaceIdFormControl(): UntypedFormControl {
    return this.createClassForm.controls.placeId as UntypedFormControl;
  }

  get LongitudeFormControl(): UntypedFormControl {
    return this.createClassForm.controls.longitude as UntypedFormControl;
  }

  get LatitudeFormControl(): UntypedFormControl {
    return this.createClassForm.controls.latitude as UntypedFormControl;
  }

  get PlaceNameControl(): UntypedFormControl {
    return this.createClassForm.controls.placeName as UntypedFormControl;
  }

  get GetSelectedBehaviour(): any {
    return this.createClassForm.controls.selectedBehaviourType.value;
  }

  get GetSelectedClassSubType(): any {
    return this.createClassForm.controls.classSubType.value;
  }

  get isFormValid(): boolean {
    this.createClassForm.updateValueAndValidity();
    return this.createClassForm.valid;
  }

  get OStaffStatus(): Ienum<StaffStatus>[] {
    return Object.entries(StaffStatus).filter(key => typeof key[1] != 'number').map(([key, value]) => ({ key, value }));
  }

  get GetAcceptsTrialFormControl(): UntypedFormControl {
    return this.createClassForm.controls.accepts_trial as UntypedFormControl;
  }

}
